import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/Home'
import Order from '@/components/Order'
import Review from '@/components/Review'
import Confirmation from '@/components/Confirmation'

Vue.use(Router)

export default new Router({
    mode: 'history',
    scrollBehavior: (to, from, savedPosition) => {
        if (to.hash) {
            return {
                selector: to.hash
            }
        }
        if (savedPosition) {
            return savedPosition
        } else {
            return {x: 0, y: 0}
        }
    },
    routes: [
        {path: '/', name: 'home', component: Home},
        {path: '/order', name: 'order', component: Order},
        {path: '/review', name: 'review', component: Review},
        {path: '/confirmation', name: 'confirmation', component: Confirmation},
    ]
})



// WEBPACK FOOTER //
// ./src/router/index.js